class ScrollTop {
	constructor() {
		this.scrollTop();
	}

	scrollTop() {
		const scrollTop = document.querySelector("#scroll-top");

		scrollTop.addEventListener("click", function (event) {
			event.preventDefault();
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		});

		window.addEventListener("scroll", function () {
			if (window.scrollY >= 600) {
				scrollTop.style.opacity = 1;
			} else {
				scrollTop.style.opacity = 0;
			}
		});
	}
}

new ScrollTop();
